import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const TransactionsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		policyno: yup.string().required().label($t('policyno')),
		transactiondate: yup.string().required().label($t('transactiondate')),
		period: yup.number().nullable().label($t('period')),
		ac_code: yup.string().required().label($t('acCode')),
		branchcode: yup.string().nullable().label($t('branchcode')),
		empcode: yup.string().nullable().label($t('empcode')),
		debit: yup.number().required().label($t('debit')),
		credit: yup.number().required().label($t('credit')),
		remarks: yup.string().nullable().label($t('remarks')),
		maturity_yn: yup.array().min(1).label($t('maturityYn')),
		created_by: yup.number().nullable().label($t('createdBy'))
	});
	// form default values
	const formDefaultValues = {
		policyno: '', 
		transactiondate: new Date(), 
		period: '', 
		ac_code: '', 
		branchcode: '', 
		empcode: '', 
		debit: '', 
		credit: '', 
		remarks: '', 
		maturity_yn: [], 
		created_by: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/transactions`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="TransactionsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editTransaction')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('policyno')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/policyno_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="policyno"     optionLabel="label" optionValue="value" value={formik.values.policyno} onChange={formik.handleChange} options={response} label={$t('policyno')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.policyno)}   />
                                                    <ErrorMessage name="policyno" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('transactiondate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="transactiondate" showButtonBar className={inputClassName(formik?.errors?.transactiondate)} dateFormat="yy-mm-dd" value={formik.values.transactiondate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="transactiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('period')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="period"  onChange={formik.handleChange}  value={formik.values.period}   label={$t('period')} type="number" placeholder={$t('enterPeriod')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.period)} />
                                                <ErrorMessage name="period" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acCode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/ac_code_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="ac_code"     optionLabel="label" optionValue="value" value={formik.values.ac_code} onChange={formik.handleChange} options={response} label={$t('acCode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.ac_code)}   />
                                                    <ErrorMessage name="ac_code" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('branchcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/branchcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={formik.handleChange} options={response} label={$t('branchcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                    <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('debit')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="debit"  onChange={formik.handleChange}  value={formik.values.debit}   label={$t('debit')} type="number" placeholder={$t('enterDebit')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.debit)} />
                                                <ErrorMessage name="debit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('credit')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit"  onChange={formik.handleChange}  value={formik.values.credit}   label={$t('credit')} type="number" placeholder={$t('enterCredit')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.credit)} />
                                                <ErrorMessage name="credit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('remarks')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="remarks"  onChange={formik.handleChange}  value={formik.values.remarks}   label={$t('remarks')} type="text" placeholder={$t('enterRemarks')}        className={inputClassName(formik?.errors?.remarks)} />
                                                <ErrorMessage name="remarks" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maturityYn')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.deductable.map((option) => {
                                                return (
                                                <div key={option.value} className="field-checkbox">
                                                    <Checkbox inputId={option.value} name="maturity_yn" value={option.value} onChange={formik.handleChange} checked={formik.values.maturity_yn.includes(option.value)} className={inputClassName(formik?.errors?.maturity_yn, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="maturity_yn" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('createdBy')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="created_by"  onChange={formik.handleChange}  value={formik.values.created_by}   label={$t('createdBy')} type="number" placeholder={$t('enterCreatedBy')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.created_by)} />
                                                <ErrorMessage name="created_by" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
TransactionsEditPage.defaultProps = {
	primaryKey: 'transactionid',
	pageName: 'transactions',
	apiPath: 'transactions/edit',
	routeName: 'transactionsedit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default TransactionsEditPage;
